import type { AnySceneObjectT } from "tweenly"
import { t } from "i18next"
import { selectUndoable } from "../../../helpers/selector.helpers"
import { useAppSelector } from "../../../hooks/useRedux"
import { filterAndSortSiblings, selectSortedRootObjects } from "../../../store/slices/objects.slice"
import EmptyPanel from "../../common/EmptyPanel"
import FadingScrollContainer from "../../common/FadingScrollContainer"
import ObjectsTreeActions from "./ObjectsTreeActions"
import ObjectTreeNode from "./ObjectsTreeNode"

const ObjectsTree = () => {
    const objects: AnySceneObjectT[] = useAppSelector((state) =>
        selectSortedRootObjects(selectUndoable(state).objects)
    )

    if (objects.length === 0)
        return (
            <FadingScrollContainer>
                <div>
                    <ObjectsTreeActions />
                </div>
                <EmptyPanel
                    title={t("editor:emptyPanel.objectTree.title")}
                    subtitle={t("editor:emptyPanel.objectTree.subtitle")}
                />
            </FadingScrollContainer>
        )
    else
        return (
            <FadingScrollContainer>
                <div>
                    <ObjectsTreeActions />
                    {objects.map((object: AnySceneObjectT, index: number) => (
                        <ObjectTreeNode
                            key={index}
                            object={object}
                            numberOfObjects={filterAndSortSiblings(objects, object.parentId).length}
                            isHiding={false}
                            isLocking={false}
                            isExpanded={object.isExpanded}
                        />
                    ))}
                </div>
            </FadingScrollContainer>
        )
}

export default ObjectsTree
